
import { Options, Vue } from 'vue-class-component';
import Principal from '@/components/QuienesSomos.vue'; // @ is an alias to /src

@Options({
  components: {
    Principal,
  },
})
export default class Contacto extends Vue {}
